export const TYPE = {
  AIRFRAME: 0,
  ENGINE: 1,
};
